import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { useContext } from "react";
import { BoletoContext } from "../../contexts/BoletoContext";
import useBilletController from "../../controllers/BoletoController";
import { TableContainer } from "../../styles/Boleto";
import Barcode from "../Icones/Barcode";
import { enumAccountsStatus } from "../Status";

export const BoletoTable = () => {
  const { getBilletValue } = useBilletController();
  const { billetData: billets, hasError } = useContext(BoletoContext);
  const columns = [
    {
      id: "identifier",
      label: "Identificação",
      align: "center",
      disablePadding: true,
    },
    {
      id: "expireDate",
      label: "Vencimento",
      align: "center",
      disablePadding: true,
    },
    {
      disabled: true,
      id: "status",
      label: "Situação",
      align: "center",
      format: (item) => enumAccountsStatus[item],
      disablePadding: true,
    },
    {
      disabled: true,
      id: "value",
      label: "Valor",
      align: "center",
      format: (item) => getBilletValue(item),
      disablePadding: true,
    },
    {
      disabled: true,
      id: "boleto",
      label: "",
      align: "right",
      format: (item) => {
        return (
          <Tooltip
            title={item ? "Baixar boleto" : "Boleto indisponível"}
            style={{ cursor: !item && "not-allowed" }}
          >
            <a
              href={item && `data:application/pdf;base64,${item}`}
              download={item && "boleto.pdf"}
            >
              <Barcode size={24} color={item ? "#020202" : "#e0e0e0"} />
            </a>
          </Tooltip>
        );
      },
    },
  ];
  return (
    <TableContainer>
      <Table sx={{ minWidth: 700 }} aria-label="customized table" stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell align={column.align} key={column.id}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {hasError ? (
            <TableRow>
              <TableCell align="center" colSpan={5}>
                Ocorreu um erro ao carregar seus boletos
              </TableCell>
            </TableRow>
          ) : billets?.length ? (
            billets?.map((billet) => (
              <TableRow key={billet.identifier}>
                {columns.map((column) => (
                  <TableCell align={column.align} key={column.id}>
                    {column.format
                      ? column.format(billet[column.id])
                      : billet[column.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell align="center" colSpan={5}>
                Sem Boletos
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
